import React, { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import { DELETE_EXPENSE } from "../../../Schema/Expense";

const useDeleteExpense = ({ handleClose, setRefetch, id }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [deleteExpense] = useMutation(DELETE_EXPENSE, {
    onCompleted: ({ deleteExpense }) => {
      setLoading(false);
      if (deleteExpense?.isSuccess === true) {
        setAlert(true, "success", deleteExpense?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteExpense?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteExpense({
      variables: {
        id: id,
      },
    });
  };

  return { deleteExpense, loading, setLoading, handleDelete };
};

export default useDeleteExpense;
